import { Component } from '@angular/core';
import { CustomButtonComponent } from "../../../../../shared/components/custom-button/custom-button.component";
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-delete-file-dialog',
  standalone: true,
  imports: [CustomButtonComponent, TranslocoPipe],
  templateUrl: './delete-file-dialog.component.html',
  styleUrl: './delete-file-dialog.component.css'
})
export class DeleteFileDialogComponent {
  modalDialogId: string = 'archive_modal_delete_file';
  private dialogResponsePromise!: (value: boolean) => void;

  openModal(): Promise<boolean> {
    const modal = document.getElementById(this.modalDialogId) as HTMLDialogElement;
    if (modal) {
      modal.showModal();

      return new Promise<boolean>((resolve) => { this.dialogResponsePromise = resolve; });
    }

    return Promise.resolve(false);
  }

  closeModal(dialogResponse: boolean): void {
    const modal = document.getElementById(this.modalDialogId) as HTMLDialogElement;
    if (modal) {
      modal.close();
      this.dialogResponsePromise(dialogResponse);
    }
  }
}
